import {
  DeliveryPeriodsByPeriodType,
  DeliveryPeriodsByShop,
  DeliveryPeriodType,
} from '../../../models/config-strip-state.models';

export const getAnySelectedPeriod = (
  deliveryPeriods: DeliveryPeriodsByPeriodType,
): DeliveryPeriodsByPeriodType => {
  const futurePeriods = deliveryPeriods[DeliveryPeriodType.Future];
  const hasFuturePeriods =
    (futurePeriods &&
      futurePeriods.deliveryPeriods &&
      futurePeriods.deliveryPeriods.length > 0) ||
    false;
  if (hasFuturePeriods) {
    return {
      ...deliveryPeriods,
      currentDeliveryPeriodType: DeliveryPeriodType.Future,
      [DeliveryPeriodType.Future]: {
        ...futurePeriods,
        selectedDeliveryPeriod: futurePeriods?.deliveryPeriods
          ? futurePeriods.deliveryPeriods[0]
          : undefined,
      },
    };
  }

  const bulkPeriods = deliveryPeriods[DeliveryPeriodType.Bulk];
  const hasBulkPeriods =
    (bulkPeriods &&
      bulkPeriods.deliveryPeriods &&
      bulkPeriods.deliveryPeriods.length > 0) ||
    false;
  if (hasBulkPeriods) {
    return {
      ...deliveryPeriods,
      currentDeliveryPeriodType: DeliveryPeriodType.Bulk,
      [DeliveryPeriodType.Bulk]: {
        ...bulkPeriods,
        selectedDeliveryPeriod: bulkPeriods?.deliveryPeriods
          ? bulkPeriods.deliveryPeriods[0]
          : undefined,
      },
    };
  }

  return {
    ...deliveryPeriods,
    currentDeliveryPeriodType: undefined,
  };
};

export const updateShopsWithAnyDeliveryPeriod = (
  deliveryPeriodsByShop: DeliveryPeriodsByShop,
): DeliveryPeriodsByShop => {
  return Object.keys(deliveryPeriodsByShop).reduce((result, key) => {
    const shopDelivery = deliveryPeriodsByShop[key];
    return {
      ...result,
      [key]: getAnySelectedPeriod(shopDelivery),
    } as DeliveryPeriodsByShop;
  }, {} as DeliveryPeriodsByShop);
};
